import { render, staticRenderFns } from "./cms-icon.vue?vue&type=template&id=e645ae12&scoped=true&"
import script from "./cms-icon.vue?vue&type=script&lang=js&"
export * from "./cms-icon.vue?vue&type=script&lang=js&"
import style0 from "./cms-icon.vue?vue&type=style&index=0&id=e645ae12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e645ae12",
  null
  
)

export default component.exports